<template>
  <div class="bmi-box">
    <span class="title">成年人BMI自测</span>
    <a-form :form="form" @reset="handleReset" @submit="handleSubmit">
      <a-form-item label="身高（cm）" :label-col="{span: 3}" :wrapper-col="{span: 8}">
        <a-input
            placeholder="例：170"
            type="number"
            v-decorator="['height',{rules:[{required: true, message: '请输入您的身高!'}]}]" />
      </a-form-item>
      <a-form-item label="体重（kg）" :label-col="{span: 3}" :wrapper-col="{span: 8}">
        <a-input
            placeholder="例：60"
            type="number"
            v-decorator="['weight',{rules:[{required: true, message: '请输入您的体重!'}]}]" />
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 12, offset: 4 }">
        <a-button type="primary" html-type="submit">
          查看结果
        </a-button>
        <a-button html-type="reset" @click="handleReset" style="margin-left: 20px">
          我要重做
        </a-button>
      </a-form-item>
    </a-form>
    <div class="result-box">
      <span class="result-text">测试结果</span>
      <div class="bmi">您的BMI指数为：<span :style="{color: result.fontColor}">{{ result.BMI }}</span></div>
      <div class="bmi">您的体重状况为：<span :style="{color: result.fontColor}">{{ result.BMIDesc }}</span></div>
      <a-table :columns="columns"
               :data-source="dataSource"
               :pagination="false"
               bordered />
      <p class="desc">
        温馨提醒：减肥的两大原则是减少摄入和增加消耗，最好能够双管齐下，一方面调整饮食，一方面加强运动。另外，多补充复合维生素对减肥也极有帮助，而且事实上不管是采取哪一种减肥方式，维生素的补充都是不能忽略的。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: this.$form.createForm(this, {}),
      result: {
        BMI: undefined,
        BMIDesc: '',
        fontColor: undefined
      },
      columns: [{
        title: '体重状况', align: 'center', dataIndex: 'result',
        customCell: (record, rowIndex) => {
          return {
            style: {
              color: record.color
            }
          }
        }
      },
        { title: '中国参考标准', align: 'center', dataIndex: 'standard' },
        { title: '相关疾病发病的危险性', align: 'center', dataIndex: 'desc' }],
      dataSource: [
        { key: 0, result: '偏瘦', standard: 'BMI指数 < 18.5', desc: '增加（相关疾病：贫血、血尿等）', color: '#0C62FF' },
        { key: 1, result: '正常', standard: '18.5 ≤ BMI指数 ≤ 23.9', desc: '平均水平', color: '#4ea013' },
        { key: 2, result: '偏胖', standard: '23.9 < BMI指数 ≤ 26.9', desc: '增加（相关疾病：高血压、心脏病等）', color: '#ffd70c' },
        { key: 3, result: '肥胖', standard: '26.9 < BMI指数 ≤ 29.9', desc: '中度增加（相关疾病：高血压、心脏病等）', color: '#ff0c9e' },
        { key: 4, result: '重度肥胖', standard: 'BMI指数 > 29.9', desc: '严重增加（相关疾病：高血压、心脏病等）', color: '#ff0c0c' }
      ]
    };
  },
  methods: {
    /** 提交查看结果 */
    handleSubmit() {
      this.form.validateFields((error, values) => {
        if (error === null) {
          let BMI = values.weight / ((values.height / 100) * (values.height / 100));
          BMI = (Math.round(BMI * 10) / 10);
          this.result.BMI = BMI;
          let resultIndex = 0;
          if (BMI < 18.5) {
            resultIndex = 0;
          } else if (BMI <= 23.9) {
            resultIndex = 1;
          } else if (BMI <= 26.9) {
            resultIndex = 2;
          } else if (BMI <= 29.9) {
            resultIndex = 3;
          } else {
            resultIndex = 4;
          }
          this.result.BMIDesc = this.dataSource[resultIndex].result;
          this.result.fontColor = this.dataSource[resultIndex].color;
        }
      })
    },

    /** 重置 */
    handleReset() {
      this.form.resetFields();
      this.result.BMI = '';
      this.result.BMIDesc = '';
    }
  },
};
</script>

<style lang="less" scoped>
.bmi-box {
  padding-left: 15px;

  .title {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 20px;
    display: inline-block;
  }

  .result-box {
    margin-top: 20px;

    .result-text {
      font-size: 16px;
      font-weight: bold;
    }

    .bmi {
      margin: 10px;

      span {
        font-weight: bold;
        font-size: 18px;
      }
    }

    .desc {
      margin-top: 10px;
      font-size: 14px;
      color: #999;
    }
  }
}
</style>